<template>
  <b-tabs v-if="tasks.length">
    <b-tab v-for="task in tasks" :title="task.task.name" :key="task.id">
      <schedule-task-results
        :instances="task.instances"
        :task="task.task"
        :samples="task.samples"
        :analyses="task.analyses"
      ></schedule-task-results>
    </b-tab>
  </b-tabs>
</template>

<script>
import ScheduleTaskResults from "@/components/lab/schedule/ScheduleTaskResults";

export default {
  name: "ScheduleProcessResults",
  components: {
    ScheduleTaskResults
  },
  props: {
    tasks: {
      type: Array,
      default: () => []
    }
  }
};
</script>
